// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2aSnv","list":"styles_list__2Acc8"};